<!--Klassifiierung-->
<div class="dx-fieldset">
  <div class="dx-field-label">{{ 'Klassifizierungssysteme' | translate }}</div>
  <div class="dx-field">
    <div class="dx-field-value">
      <dx-tag-box [(value)]="selectedClassificationSystemIds"
                  [dataSource]="classificationSystems"
                  displayExpr="name"
                  valueExpr="id"
                  [acceptCustomValue]="false"
                  placeholder=""
                  class="hint"
                  [readOnly]="readOnlyUser('classifiction')"
                  (onValueChanged)="onTagBoxChange($event)">
      </dx-tag-box>
    </div>
  </div>
</div>
